import React, { Component } from 'react';
import 'dhtmlx-scheduler';
import 'dhtmlx-scheduler/codebase/dhtmlxscheduler.css';
import './Scheduler.css';

const scheduler = window.scheduler;

export default class Scheduler extends Component {

    initSchedulerEvents() {
        if (scheduler._$initialized) {
            return;
        }
        // Prevent the default lightbox from showing when an event is clicked
        scheduler.attachEvent("onBeforeLightbox", function (id) {
            return false;
        });
        
        let popup = null;

        scheduler.attachEvent("onMouseMove", function (id, e){
            if (id) {
                // Get the event details
                const event = scheduler.getEvent(id);

                // Remove the existing popup if there is one
                if (popup) {
                    document.body.removeChild(popup);
                }

                // Create a new popup
                popup = document.createElement('div');
                popup.style.position = 'fixed';
                popup.style.backgroundColor = '#fff';
                popup.style.border = '1px solid #ccc';
                popup.style.borderRadius = '10px';
                popup.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.2)';
                popup.style.padding = '10px';
                popup.style.width = '300px';
                popup.style.height = 'auto';
                popup.style.overflowY = 'auto';

                // Position the popup at the mouse cursor
                popup.style.top = `${e.clientY + 10}px`;
                popup.style.left = `${e.clientX}px`;

                // Center the content inside the popup
                popup.style.display = 'flex';
                popup.style.flexDirection = 'column';
                popup.style.justifyContent = 'center';
                popup.style.alignItems = 'center';

                // Add the event details to the popup
                const eventText = document.createElement('p');
                eventText.innerHTML = event.text.replace(/\nEmpleados/g, '<br>Empleados').replace(/\n/g, '<br>- ');
                popup.appendChild(eventText);

                // Add the popup to the body
                document.body.appendChild(popup);
            } else {
                // Remove the popup when the mouse leaves the event
                if (popup) {
                    document.body.removeChild(popup);
                    popup = null;
                }
            }
        });

        scheduler.attachEvent("onMouseOut", function (id, e) {
            // Remove the popup when the mouse leaves the event
            if (popup) {
                document.body.removeChild(popup);
                popup = null;
            }
        });
        scheduler._$initialized = true;
    }

    componentDidMount() {
        scheduler.skin = 'material';
        scheduler.config.header = [
            'month',
            'date',
            'prev',
            'next'
        ];
        scheduler.config.readonly = true;
        scheduler.locale.labels.section_description = "Descripción";

        this.initSchedulerEvents();

        const { events } = this.props;
        scheduler.init(this.schedulerContainer, new Date(), 'month');
        scheduler.attachEvent('onDataRender', function() {
            var elements = document.getElementsByClassName('dhx_cal_event_line_content');
            for (var i = 0; i < elements.length; i++) {
                var element = elements[i];
                if (element.textContent.includes('Viaje')) {
                    element.classList.add('viaje-event');
                } else if (element.textContent.includes('O/T')) {
                    element.classList.add('ot-event');
                }
            }
            var dates = document.getElementsByClassName('dhx_cal_event_clear_date');
            for (var l = 0; l < dates.length; l++) {
                var date = dates[l];
                date.textContent = ""
            }
            return true;
        });
        scheduler.clearAll();
        scheduler.parse(events);
    }

    shouldComponentUpdate(nextProps) {
        return this.props.timeFormatState !== nextProps.timeFormatState;
    }

    componentDidUpdate() {
        scheduler.render();
    }

    setHoursScaleFormat(state) {
        scheduler.config.hour_date = state ? '%H:%i' : '%g:%i %A';
        scheduler.templates.hour_scale = scheduler.date.date_to_str(scheduler.config.hour_date);
    }

    
    render() {
        const { timeFormatState } = this.props;
        this.setHoursScaleFormat(timeFormatState);
        return (
            <div
                ref={ (input) => { this.schedulerContainer = input } }
                style={ { width: '100%', height: '100%' } }
            ></div>
        );
    }
}
